import { TUnknownParam } from '@utils/diff/helpers';

class OOLogger {
  private readonly _ooEndpoint: string = '/api/front/v2/logs/streaming';

  public async reportError(errorType: string, context: Record<string, TUnknownParam>): Promise<void> {
    try {
      await fetch(this._ooEndpoint, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          doppioLifecycleError: {
            errorType,
            context,
          },
        }),
      });
    } catch (_e) {
      // ignore logging error;
    }
  }
}

export const OpenObserveLogger: OOLogger = new OOLogger();
